<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{product.name}}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <p>{{product.description}}</p>
        <p>
            {{'Price gross'|translate}}: {{product.priceGross}}<br/>
            {{'VAT rate'|translate}}: {{product.vatRate.vatName}}
        </p>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="OK">
            {{'OK'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close('add-to-bill')"
                aria-label="Add to bill"
        >
            {{'Add to bill'|translate}}
        </button>

    </div>
</div>
